module.exports = __webpack_public_path__ + "images/input_phone_icon.fc41e73b.png";